import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { Button, Pagination, Select, Table } from "antd";
import ButtonGroup from "antd/es/button/button-group";
import Search from "antd/es/input/Search";
import { Option } from "antd/es/mentions";
import Modal from "antd/es/modal/Modal";
import moment from "moment";

import nutrientsApi from "../../../../apis/Nutrients.api";
import requestApi from "../../../../apis/Request.api";
import {
  setLoading,
  setSearchText,
} from "../../../../redux/store/common/commonDuck";

/**
 * 신청 영양제
 * status : 0,      // 0 : 신청상태 , 1 : 헬시팀 컨펌
 * certify : false,  // false : 미인증 , true : 인증
 * confirm : 0      // 0 : 대기 , 1 : 승인 , 2 : 반려
 * **/

/**
 * pageType         // 1 : 인증 , 2 : 레시피(or 반려) , 3 : 신청 , 4 : 추가
 * target_type      // 1 : 음식 , 2 : 재료 , 3 : 영양제
 **/

const NutrientsRequestComponent = () => {
  let history = useHistory();
  const dispatch = useDispatch();

  const user = useSelector((state) => state.auth.user);
  const isLoading = useSelector((state) => state.common.loading);
  const searchText = useSelector((state) => state.common.searchText);

  const setIsLoading = (value) => dispatch(setLoading(value));
  const setIsSearchText = (value) => dispatch(setSearchText(value));

  const [selectedData, setSelectedData] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [isCertifyModalVisible, setIsCertifyModalVisible] = useState(false);
  const [isRejectModalVisible, setIsRejectModalVisible] = useState(false);
  const [error, setError] = useState("");
  const [pageSize, setPageSize] = useState(10);
  const [offset, setOffset] = useState(0);
  const [totalSize, setTotalSize] = useState(100);
  const [searchType, setSearchType] = useState("vuon");
  const [orderType, setOrderType] = useState("");
  const [orderBy, setOrderBy] = useState("");
  const [currentPageNumber, setCurrentPageNumber] = useState(1);
  const [isSearch, setIsSearch] = useState(false);
  const [nutrientsData, setNutrientsData] = useState([]);

  const searchItems = [
    { searchType: "vuon", searchText: "뷰온검색" },
    { searchType: "name", searchText: "영양제명" },
    { searchType: "brand_name", searchText: "브랜드명" },
    { searchType: "category", searchText: "카테고리" },
  ];

  const [confirmHistory, setConfirmHistory] = useState({
    target_type: 3,
    confirm: 0,
    confirm_reason: "",
  });

  const columns = [
    {
      title: "신청내용",
      width: 660,
      dataIndex: "name",
      key: "name",
      fixed: "left",
      ellipsis: true,
      onCell: (record) => {
        return {
          onClick: () => {
            history.push(`/nutrients/view/request/${record.id}`);
          },
        };
      },
      // sorter: (a, b) => {},
    },
    {
      title: "승인/반려",
      dataIndex: "confirm",
      key: "confirm",
      width: 90,
      ellipsis: true,
      onCell: (record) => {
        return {
          onClick: () => {
            history.push(`/nutrients/view/request/${record.id}`);
          },
        };
      },
      render: (e) => {
        return e === 1 ? "승인" : e === 2 ? "반려" : "대기중";
      },
      // sorter: (a, b) => {},
    },
    {
      title: "생성일",
      dataIndex: "created_at",
      key: "created_at",
      width: 150,
      render: (e) => {
        return e === null ? "-" : moment(e).format("YYYY-MM-DD HH:mm");
      },
      ellipsis: true,
      // sorter: (a, b) => {},
    },
    {
      title: "생성자",
      dataIndex: "created_by_name",
      key: "created_by_name",
      render: (e) => {
        return e === 0 ? "Admin" : e;
      },
      width: 100,
      ellipsis: true,
    },
    {
      title: "수정일",
      dataIndex: "updated_at",
      key: "updated_at",
      render: (e) => {
        return e === null ? "-" : moment(e).format("YYYY-MM-DD HH:mm");
      },
      width: 150,
      // sorter: (a, b) => {},
      ellipsis: true,
    },
    {
      title: "수정자",
      dataIndex: "updated_by",
      key: "updated_by",
      render: (e) => {
        return e === 0 ? "Admin" : e;
      },
      width: 100,
      ellipsis: true,
    },
    {
      title: "",
      key: "handleData",
      fixed: "right",
      width: 100,
      ellipsis: true,
      render: () => <a>자세히</a>,
    },
  ];

  useEffect(() => {
    getReadNutrientsData();
    getTotalSize();
  }, [searchText, pageSize, orderType, orderBy, offset]);

  /**
   * 영양제목록 가져오기
   * @param {*} offset
   * @param {*} PageSi중ze
   * @param {*} searchType
   * @param {*} searchText
   * @param {*} orderType
   * @param {*} orderBy
   * @param {*} requestType 1 // 1:음식신청 2:재료신청 3: 영양제신청
   */
  const getReadNutrientsData = async () => {
    setIsLoading(true);
    try {
      setError("");
      const res = await requestApi.readRequest(
        offset,
        pageSize,
        searchType,
        searchText,
        orderType,
        orderBy,
        3,
      );
      if (res.code === 200) {
        setNutrientsData(res.result);
      } else {
        alert("정상적인 요청이 아닙니다.");
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setError(error);
      console.log("nutrientsData read error", error);
    }
  };

  /**
   * 테이블 변경 이벤트가 이루어졌을때
   * @param {*} pagination
   * @param {*} filters
   * @param {*} sorter
   * @param {*} extra
   */
  const tableOnChange = (pagination, filters, sorter, extra) => {
    if (sorter) {
      //sorting 이벤트가 이루어졌을때
      if (sorter.order) {
        if (sorter.order === "descend") {
          setOrderBy("desc");
        } else if (sorter.order === "ascend") {
          setOrderBy("asc");
        }
        setOrderType(sorter.field);
        //sorting 이벤트 데이터가 초기화 되었을 시 (order 값 초기화)
      } else {
        setOrderType("created_at");
        setOrderBy("desc");
      }
    }
  };

  /**
   *  목록 총 사이즈 가져오기
   */
  const getTotalSize = async () => {
    setIsLoading(true);
    try {
      setError("");
      const res = await nutrientsApi.totalCntList(searchText, searchType, 3);
      if (res.code === 200) {
        setIsLoading(false);
        setTotalSize(res.result.totalCnt);
      } else {
        setIsLoading(false);
        alert("정상적인 요청이 아닙니다.");
      }
    } catch (error) {
      setIsLoading(false);
      setError(error);
      console.log("nutrients totalCnt error", error);
    }
  };

  const pageSizeChange = (current, pageSize) => {
    setPageSize(pageSize);
    setOffset((current - 1) * 10);
    setCurrentPageNumber(1);
  };

  const handleChangeOffset = (pageNumber) => {
    const offset = (pageNumber - 1) * 10;
    setCurrentPageNumber(pageNumber);
    setOffset(offset);
  };

  const onSearchNutrients = (value) => {
    setIsSearchText(value);
    setOffset(0);
    setCurrentPageNumber(1);
    setIsSearch(!isSearch);
  };

  const onChangeSearchType = (value) => {
    setSearchType(value);
  };

  const showCertifyModal = () => {
    setIsCertifyModalVisible(true);
  };
  const showRejectModal = () => {
    setIsRejectModalVisible(true);
  };

  const handleRejectOk = () => {
    handleCancel();
    for (let i = 0; i < selectedData?.length; i++) {
      handleReject(
        {
          ...selectedData[i],
          status: 1,
          type: 1,
          updated_by: user.id,
          is_certify: false,
        },
        { ...confirmHistory, confirm: 2, confirm_reason: "반려사유 테스트" },
      );
      if (i + 1 === selectedData?.length) {
        window.alert("반려완료");
        setSelectedRowKeys([]);
        getReadNutrientsData();
      }
    }
  };

  const handleCertifyOk = () => {
    handleCancel();
    for (let i = 0; i < selectedData?.length; i++) {
      handleCertify(
        {
          ...selectedData[i],
          status: 1,
          type: 1,
          updated_by: user.id,
          is_certify: true,
        },
        { ...confirmHistory, confirm: 1, confirm_reason: "승인 테스트" },
      );
      if (i + 1 === selectedData?.length) {
        window.alert("승인완료");
        setSelectedRowKeys([]);
        getReadNutrientsData();
      }
    }
  };

  const handleCancel = () => {
    setIsRejectModalVisible(false);
    setIsCertifyModalVisible(false);
  };

  const handleCertify = async (e, confirm) => {
    setIsLoading(true);
    try {
      const newEditNutrients = {
        nutrients: e,
        nutrients_nutrient: e,
        confirmHistory: confirm,
      };
      const res = await nutrientsApi.editNutrients(newEditNutrients);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log(error);
      setError(error);
    }
  };

  const handleReject = async (e, confirm) => {
    setIsLoading(true);
    try {
      setError("");
      const newEditNutrients = {
        nutrients: e,
        nutrients_nutrient: e,
        confirmHistory: confirm,
      };
      const res = await nutrientsApi.editNutrients(newEditNutrients);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log(error);
      setError(error);
    }
  };

  const removeNutrientsData = async (id) => {
    setIsLoading(true); // 추가설정해야함. 팀장님거 참고하기.
    try {
      const res = await nutrientsApi.removeNutrients(id);
      if (res.code === 200) {
        /* empty */
      } else {
        alert("정상적인 요청이 아닙니다.");
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log(error);
      setError(error);
    }
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowKeys(selectedRowKeys);
      setSelectedData(selectedRows);
    },
  };

  const selectedDelete = () => {
    for (let i = 0; i < selectedData?.length; i++) {
      removeNutrientsData(selectedData[i].id);
      if (i + 1 === selectedData?.length) {
        window.alert("삭제완료");
        setSelectedRowKeys([]);
        getReadNutrientsData();
      }
    }
  };

  return (
    <>
      <div
        style={{
          marginBottom: 20,
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div className="searchBox">
          <Select
            style={{ width: 120, textAlign: "left" }}
            defaultValue={searchType}
            onChange={onChangeSearchType}
          >
            {searchItems.map((item) => {
              return <Option value={item.searchType}>{item.searchText}</Option>;
            })}
          </Select>
          <Search
            placeholder="input search text"
            allowClear
            enterButton="Search"
            size="middle"
            defaultValue={searchText}
            onSearch={onSearchNutrients}
            style={{ width: 250 }}
          />
        </div>
        <ButtonGroup
          style={{
            marginTop: 10,
            marginRight: 40,
            display: "flex",
            justifyContent: "right",
          }}
        >
          <div style={{ paddingTop: "5px" }}>
            Total : {totalSize.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
          </div>
          {/*<Button style={{width: 120, height: 30, marginLeft: 20, marginBottom: 20, borderColor:"#00c5ff"}} onClick={showCertifyModal}>선택영양제승인</Button>*/}
          {/*<Button style={{width: 120, height: 30, marginLeft: 20, marginBottom: 20,borderColor:"#ff8900"}} onClick={showRejectModal}>선택영양제반려</Button>*/}
          <Button
            style={{
              width: 120,
              height: 30,
              marginLeft: 20,
              marginBottom: 20,
              borderColor: "#ff0000",
            }}
            onClick={selectedDelete}
          >
            {" "}
            선택영양제삭제{" "}
          </Button>
          {/*<Button style={{width: 120, height: 30, marginLeft: 20, marginBottom: 20, borderColor:"#17721b"}} onClick={() => {*/}
          {/*    history.push(`/nutrients/request/create`)*/}
          {/*}}>영양제추가</Button>*/}
        </ButtonGroup>
      </div>
      <Modal
        title="영양제정보 승인"
        visible={isCertifyModalVisible}
        maskClosable={false}
        onOk={handleCertifyOk}
        onCancel={handleCancel}
      >
        <p>선택된 영양제정보를 승인하시겠습니까?</p>
      </Modal>

      <Modal
        title="영양제정보 반려"
        visible={isRejectModalVisible}
        maskClosable={false}
        onOk={handleRejectOk}
        onCancel={handleCancel}
      >
        <p>선택된 영양제정보를 반려하시겠습니까?</p>
      </Modal>
      <Table
        rowSelection={rowSelection}
        columns={columns}
        dataSource={nutrientsData}
        bordered
        loading={isLoading}
        rowKey="id"
        onChange={tableOnChange}
        size="middle"
        scroll={{ x: "calc(700px + 50%)" }}
        pagination={false}
      />

      <div style={{ textAlign: "right" }}>
        <Pagination
          showQuickJumper
          showSizeChanger
          onShowSizeChange={pageSizeChange}
          total={totalSize}
          onChange={handleChangeOffset}
          style={{ marginTop: 20 }}
          current={currentPageNumber}
        />
      </div>
    </>
  );
};
export default NutrientsRequestComponent;
